import { render, staticRenderFns } from "./swFAQ.vue?vue&type=template&id=661489be&scoped=true&"
import script from "./swFAQ.vue?vue&type=script&lang=js&"
export * from "./swFAQ.vue?vue&type=script&lang=js&"
import style0 from "./swFAQ.vue?vue&type=style&index=0&id=661489be&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "661489be",
  null
  
)

export default component.exports